import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../../theme';
import CdnImage from '../../../CdnImage/CdnImage';

interface Props {
	title?: string;
	description: string;
}

const EmptyPage: FC<Props> = ({ title, description }) => {
	const { t } = useTranslation('Account');
	const { EmptyPage: css } = useTheme('Account');

	return (
		<div className={css.root}>
			<div className={css.header}>
				<CdnImage path="https://cdn.websky.aero/content/frontend/images/emojy/sorry.svg" />

				<div className={css.title}>{title || t('Sorry')}</div>
			</div>

			{description && <div className={css.description}>{description}</div>}
		</div>
	);
};

export default EmptyPage;
